module.exports = __webpack_public_path__ + "media/images/article/polygon_03-c93afddb3987865c240197c0b8735ac8.png";